$(document).ready(function() {
  
   //T&Cs agreement checkbox 
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
        if ($("#tandcs:checked,#shipping:checked").length == 2) {
        $(this).submit();
      }
      else {
        alert("You must agree with the Terms and Conditions and Shipping Policy to check out.");
        return false;
      }
    })
  
  
//   Size / Qty
  $(".size-list li").click(function() {
    
    if($(this).find('a[data-value="Various"]').length) {
      $('.po-accordion-group[data-group-name="Sizes / Qty"]').addClass("show-anyway");    
      qty_validate();
      
    }
    else {
      $('.po-accordion-group[data-group-name="Sizes / Qty"]').removeClass("show-anyway");    	
      if(!$('.warn-qty').hasClass("hidden")) {
      	$('.warn-qty').addClass("hidden");
      }
      
      if(!$('.warn-vary').hasClass("hidden")) {
      	$('.warn-vary').addClass("hidden");
      }
      
      $(".product-options-number").each(function() {
      	$(this).val("");
      });
      
      activate_buy(true); 
    }
  })
  
  $(".qty-input").change(function() {
    if($('a[data-value="Various"]').parent().hasClass("active")) {
    setTimeout(function() {
          qty_validate();
      }, 200);
    }    
  })
  
  $(".increase").click(function() {
    if($('a[data-value="Various"]').parent().hasClass("active")) {
      setTimeout(function() {
          qty_validate();
      }, 200);
    }    
  })
  
  $(".decrease").click(function() {
    if($('a[data-value="Various"]').parent().hasClass("active")) {
      setTimeout(function() {
          qty_validate();
      }, 200);
    }  	
  })
 
  $(document).on("change, mouseup, keyup", ".product-options-number", qty_validate);
  
//   $(".product-options-number").on('input', function() { 
//     qty_validate();  	
//   })

  

  
  function qty_validate() {
  	var tot = parseInt($(".qty-input").val());
    var sub_tot = 0;
    var q_flag = true;
    if ( $(".product-options-number").length > 0) {
    $(".product-options-number").each(function() {
      if($(this).val().length > 0) {
      	sub_tot += parseInt($(this).val());
      }
      
      //     Color/Size Variant check
//       var $psz = $(this).prev().val();
//       var $pcol = "White";
      
//       if($(".colorpicker-selected").length > 0) {
//       	$pcol = $(".colorpicker-selected").attr("data-name");
//       }
            
//       if(q_flag == true) {
               
//         $("#ProductSelect-product-section option").each(function() {
//           $qval = $(this).text();
//           $qcol = $qval.substring($qval.indexOf("/") + 2, $qval.length - 1);
//           $qsz = $qval.substring(1, $qval.indexOf("/") - 1);

//           if($qcol == $pcol && $qsz == $psz) {
//               q_flag = true;
//           }

//         });

//       }
    }); 
    
      
    if(tot == sub_tot) {
      if(!$('.warn-qty').hasClass("hidden")) {
      	$('.warn-qty').addClass("hidden");
      }
    }
    else {
	  if($('.warn-qty').hasClass("hidden")) {
      	$('.warn-qty').removeClass("hidden");
      }
      q_flag = false;
    }  
    
    if($(".qty-input").val() == "1") {
      if($('.warn-vary').hasClass("hidden")) {
      	$('.warn-vary').removeClass("hidden");
      }
    	q_flag = false;
    }
    else {
      if(!$('.warn-vary').hasClass("hidden")) {
      	$('.warn-vary').addClass("hidden");
      }
    }
    
    activate_buy(q_flag);
  }
  }

  
// //   Colour Variant
//   $(".color-list li").click(function() {
// //   	$('.po-accordion-group[data-group-name="Colour"]').addClass("show-anyway");  
    
//     $color = $(this).find("a").attr("data-original-title");
        
//     $(".colorpicker-selected").removeClass("colorpicker-selected"); 
//     $(".product-options-colorpicker-container span[data-name='" + $color + "']").addClass("colorpicker-selected");
    
//     $('.product-options-control-container input[name="properties[Colour]"]').val('"' + $color + '"');
    
// //     $(".product-options-colorpicker-container span[data-name='" + $color + "']").hide();

//   });
  
//   var myVar = setInterval(colorbarInsert, 1000);

//   function colorbarInsert() {
//     if($(".product-options-colorpicker-container").length) {
//     	$(".color-list").after($(".product-options-colorpicker-container"));
//       	clearInterval(myVar);
//     }
//   }
  
  
//   $("body").click(function(e) {
  	    
//     $tar = $(e.target);
    
//     if($tar.hasClass("product-options-color-span")) {
      
//       $col = $tar.parent().attr("data-name");
//       $sz = $("ul[data-select-id='SingleOptionSelector-0'] .active a").attr("data-value");
      
// //       Check Variant available
//       checkVariant($col, $sz);
      
//       $sel = $tar.parent().parent().prev().prev();
            
//       $sel.find("option").each(function() {
//         if($(this).attr("selected") == "selected") {
//         	$(this).removeAttr("selected");
//         }	
        
//         if($(this).attr("value") == $col) {
//         	$(this).attr("selected", "selected");
//         }
//       })
      
//       $sel.val($col);
      
// //       Original color bar selected
//       $(".color-list li").each(function() {
//         if($(this).find("a").attr("data-value") == $col) {
//         	$(".color-list li.active").removeClass("active");
//             $(this).addClass("active");
            
//       		document.getElementById("SingleOptionSelector-1").selectedIndex = $(this).index();    
//         }
//       });
      
      
// // XXXX-Large            
//       $("#ProductSelect-product-section option").each(function() {
//         $cval = $(this).text();
//         $ccol = $cval.substring($cval.indexOf("/") + 2, $cval.length - 1);
//         $csz = $cval.substring(1, $cval.indexOf("/") - 1);

        
//         if($(this).attr("selected") == "selected") {
//         	$(this).removeAttr("selected");
//         }
        
//         if($sz == "XXXX-Large") {
//           if($csz == "XXXX-Large") {   
//             setTimeout(function() {
//           		$(this).attr("selected", "selected");
//                 $("#ProductSelect-product-section").val($(this).val());
//             }, 500);
//           }
//         }
// //         else if ($sz == "XXX-Large") {
// //           if($csz == "XXX-Large") {   
// //             setTimeout(function() {
// //           		$(this).attr("selected", "selected");
// //                 $("#ProductSelect-product-section").val($(this).val());
// //             }, 500);          	
// //           }	
// //         }
//         else{
//             if($ccol == $col && $csz == $sz) {
//             	$(this).attr("selected", "selected");
//             }
//         }
        
//       })
      
// //       if($sz == "XXXX-Large" || $sz == "XXX-Large") {
        
//       if($sz == "XXXX-Large" ) {
//         setTimeout(function() {
//           $('.product-options-colorpicker-container input[name="properties[Colour]"]').val("White");
//           $('.product-options-colorpicker-container input[name="properties[Colour]"]').attr("value", "White");
//         }, 200);
      	
//       }
      
//     }
//   });
  
  function checkVariant(col, sz) {
    var flag = false;
    var tmp = sz + " / " + col;
    $("#ProductSelect-product-section option").each(function() {
      
      if($(this).text().trim() == tmp ) {
      	flag = true;
      }
    })
    
    activate_buy(flag);
    
    
  }
  
  function activate_buy(flag) {
    console.log(flag);
      if(!flag) {
        if($(".prd-block_actions").find('button[aria-disabled="true"]').length == 0) {
            $(".btn--add-to-cart").attr("aria-disabled", "true");
            $(".btn--add-to-cart").attr("aria-label", "Unavailable"); 	
            $(".btn--add-to-cart").addClass("btn-disabled");

            $(".prd-block_price").addClass("d-none");
            $(".btn--add-to-cart .icon-handbag").next().text("Unavailable");
        }
      }
      else {
       // while($(".prd-block_actions").find('button[aria-disabled="false"]').length){
          $(".btn--add-to-cart").removeAttr("aria-disabled");
          $(".btn--add-to-cart").removeAttr("aria-label"); 	
          $(".btn--add-to-cart").removeClass("btn-disabled");
          $(".prd-block_price").removeClass("d-none");
          $(".btn--add-to-cart .icon-handbag").next().text("ADD TO CART");
        //}
      }
  
  }
  
  setTimeout(function() {
    
    $(".switch-field input").each(function(index) {
      console.log(index);
      $(this).attr("id", "switchInput_" + index);
      if(index % 2 == 0) {
      	$(this).after("<label for='switchInput_" + index + "'>Yes</label>");
      }
      else {
      	$(this).after("<label for='switchInput_" + index + "'>No</label>");
        $(this).prop("checked", true);
      }
      
    })
    
    $('div[data-name*="Print on"]').show();
    $('div[data-name*="Embroider on"]').hide();    
  }, 5000);
  
  $( "body" ).click(function( event ) {
    if(event.target.value == "Print") {
      $('div[data-name*="Print on"]').show();
      $('div[data-name*="Embroider on"]').hide();
    }
    else if(event.target.value == "Embroidery") {
      $('div[data-name*="Print on"]').hide();
      $('div[data-name*="Embroider on"]').show();
      

    }
    
  });

});
